import { Injectable } from '@angular/core';
import { clearSession } from './session';
import { clearToken, readToken, saveToken } from './token-store';

@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  constructor() {}
  public setRoles(roles: []) {
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  public getRoles(): [] {
    // Guard against a missing/empty/malformed value: JSON.parse('') throws.
    const raw = localStorage.getItem('roles');
    if (!raw) {
      return [] as unknown as [];
    }
    try {
      return JSON.parse(raw);
    } catch {
      return [] as unknown as [];
    }
  }

  public setToken(jwtToken: string) {
    // Store obfuscated, in the 'Bearer <jwt>' format the interceptor and REST
    // service expect. See token-store.ts for the (deterrent-only) rationale.
    const value = jwtToken.startsWith('Bearer') ? jwtToken : `Bearer ${jwtToken}`;
    saveToken(value);
    return true;
  }
  // get token
  public getToken(): string {
    return readToken();
  }
  public setEmail(email: string) {
    localStorage.setItem('userEmail', email);
  }
  public getEmail(): string {
    return localStorage.getItem('userEmail') || '';
  }

  public logout() {
    // Enumerated clear rather than localStorage.clear(), so unrelated
    // preferences (theme, language) survive a sign-out.
    clearSession();
    return true;
  }
  // to check user is logged in
  public isLoggedIn() {
    return this.getRoles() && this.getToken();
    // let token = localStorage.getItem("jwtToken")
    // if (token == undefined || token === '' || token == null) {
    //   return false;
    // } else {
    //   return true
    // }
  }
}
